<template>
  <div>

    <v-row align="center">
      <v-col cols="12" sm="5">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="periodText"
              label="Período"
              prepend-inner-icon="mdi-calendar"
              readonly
              clearable
              dense
              hide-details
              v-bind="attrs"
              v-on="on"
              @click:clear="clear()"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="period"
            type="month"
            locale="pt-BR"
            :max="maxPeriod"
            no-title
            scrollable
            @change="select()"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="4" v-if="current">
        <v-alert dense text type="info" class="mb-0">
          {{ current.length }} registros encontrados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="3" v-if="current">
        <v-btn @click="csv()">CSV</v-btn>
      </v-col>
    </v-row>

    <div v-if="current">

      <v-simple-table class="mt-6">
        <thead>
          <tr>
            <th>Contato</th>
            <th>Nome</th>
            <th>Avatar</th>
            <th>Endereço</th>
            <th>Status</th>
            <th>Criado em</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in current" :key="item.id">
            <td><v-chip>{{ item.contact }}</v-chip></td>
            <td>{{ item.name }}</td>
            <td>{{ item.avatar }}</td>
            <td>{{ item.address }}</td>
            <td><v-chip small :color="colorStatus(item.status)">{{ item.status | formatStatus }}</v-chip></td>
            <td>{{ item.created | formatDate }}</td>
            <td><v-btn icon :to="'/lead/' + item.id" title="Detalhes"><v-icon>mdi-magnify</v-icon></v-btn></td>
          </tr>
        </tbody>
      </v-simple-table>

    </div>

  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: function () {
    var now = new Date();
    var month = now.getMonth() + 1;
    var period = now.getFullYear() + "-" + (month < 10 ? "0" + month : month);
    return {
      current: null,
      menu: false,
      period: period,
      maxPeriod: period,
      months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },
  computed: {
    periodText: function () {
      if (!this.period) return "Todos";
      var exp = this.period.split("-");
      return this.months[parseInt(exp[1], 10) - 1] + " / " + exp[0];
    },
  },
  created: function () {
    this.list();
  },
  methods: {
    select: function () {
      this.menu = false;
      this.list();
    },
    clear: function () {
      this.period = null;
      this.menu = false;
      this.list();
    },
    list: function () {
      var me = this;
      var token = localStorage.getItem("token");
      var params = {};
      if (me.period) {
        var exp = me.period.split("-");
        params.year = parseInt(exp[0], 10);
        params.month = parseInt(exp[1], 10);
      }
      me.current = null;
      api
        .get("/lead", {
          params: params,
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
        })
        .catch(function () {
          console.log("list fail");
        });
    },
    escapeCsv: function(value){
      var text = value == null ? "" : String(value);
      text = text.replace(/(\r\n|\n|\r)/gm, "");
      if (text.indexOf(";") >= 0 || text.indexOf("\"") >= 0) {
        text = "\"" + text.replace(/"/g, "\"\"") + "\"";
      }
      return text;
    },
    csv: function(){
      var me = this;
      var content = "";
      for(var i=0;i<this.current.length;i++){
        let lead = this.current[i];
        let created = this.$options.filters.formatDate(lead.created);
        let status = this.$options.filters.formatStatus(lead.status);
        let fields = [lead.id, lead.contact, lead.name, lead.avatar, lead.address, status, created];
        content += fields.map(function (field) { return me.escapeCsv(field); }).join(";") + "\n";
      }
      var blob = new Blob([content], { type: "text/csv" });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = url;
      let df = new Date().toISOString();
      a.download = "leads-"+df+".csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    colorStatus: function (status) {
      var ret = "default";
      if (status == 1) {
        ret = "warning";
      } else if (status == 2) {
        ret = "primary";
      } else if (status == 3) {
        ret = "success";
      }
      return ret;
    }
  },
  filters: {
    formatStatus: function (value) {
      var ret = "Desconhecido";
      if (value == 1) {
        ret = "Visitante";
      } else if (value == 2) {
        ret = "Cliente";
      } else if (value == 3) {
        ret = "Fã";
      }
      return ret;
    },
  }
};
</script>
